import { Form } from 'antd';
import styled from 'styled-components';

import { CustomerDataModel } from '~/core/models';

export const Container = styled(Form<CustomerDataModel>)(({ theme }) => ({
  margin: '10rem',

  '& .ant-modal-content': {
    background: `linear-gradient(180deg, ${theme.palette.white}, ${theme.palette.linkWater})`,
  },

  '& .ant-form-item-label': {
    paddingTop: '10rem',
    paddingBottom: '5rem',
  },
}));

export const RequiredCheckbox = styled(Form.Item)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  marginLeft: '15rem',
  padding: '0 10rem',

  '& .anticon-warning': {
    color: theme.defaultTheme.eeWarningColor,
    padding: '0 5rem 0 0',
  },

  '& input[type="checkbox"]': {
    margin: '0 5rem 0 0',
  },

  '& label': {
    margin: 0,
    color: theme.palette.erieBlack,
    fontSize: theme.typography.size14,
    fontFamily: theme.typography.family.arial,
  },
}));

export const RequiredField = styled(Form.Item)(({ theme }) => ({
  fontSize: theme.typography.size16,
  fontFamily: theme.typography.family.arial,
  color: theme.palette.erieBlack,

  '[disabled]': {
    color: theme.palette.erieBlack,
  },
  '& .ant-form-item-required::before': {
    color: `${theme.palette.erieBlack} !important`,
    marginInlineEnd: '2rem !important',
  },
}));

export const DoubleRequiredField = styled(Form.Item)(({ theme }) => ({
  '& .ant-form-item-required::before': {
    color: `${theme.palette.erieBlack} !important`,
    content: '"**" !important',
    marginInlineEnd: '2rem !important',
  },
}));
